window.LiveSumComponent = {
    get(){
        return new Promise((resolve, reject) => {
            fetch("/live-sum", {method: "GET"})
                .then(res => {
                    return res
                        .json()
                        .then(data => {
                            resolve(data.sum);
                        });
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    load(){
        if($('.live-sum-contribution-loading,.live-sum-user-loading,.live-sum-project-loading').length>0){
            LiveSumComponent.get().then(response => {
                $('.live-sum-contribution-loading').replaceWith("<span>R$"+(Math.round(response.contribution/1000000))+" milhões</span>");
                $('.live-sum-user-loading').replaceWith("<span>"+Math.ceil(response.user/1000)+" mil</span>");
                $('.live-sum-project-loading').replaceWith("<span>"+
                        ((Math.floor(response.project/100))*100)
                            .toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                    +"</span>");
            });
        }
    }
};
LiveSumComponent.load();
// ***** EXAMPLE HOW TO *****
//
// LiveSumComponent.get().then(sum => {
//     console.log(sum);
// });